<template>
    <v-list nav>
        <div v-for="(item, i) in filteredItems" :key="i">
            <v-list-group
                exact
                class="my-3"
                :key="i"
                v-if="item.children"
                v-model="item.active"
            >
                <v-icon slot="prependIcon">{{ item.icon }}</v-icon>
                <template v-slot:activator>
                    <v-list-item-content class="mr-n6">
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </template>

                <v-list-item
                    active-class="primary--text"
                    class="pr-6"
                    v-for="(subItem, ind) in getFilteredChildren(item)"
                    :key="ind"
                    :to="subItem.to"
                >
                    <v-icon small right>mdi-circle-outline</v-icon>
                    <div>{{ subItem.title }}</div>
                </v-list-item>
            </v-list-group>

            <v-list-item v-else :to="item.to" active-class="secondary--text">
                <v-icon size="22">{{ item.icon }}</v-icon>
                <v-list-item-title class="mr-3">{{
                    item.title
                }}</v-list-item-title>
            </v-list-item>
        </div>
    </v-list>
</template>

<script>
import { jwtDecode } from "jwt-decode";
import { Roles } from "../utils/roles";

export default {
    data() {
        return {
            items: [],
        };
    },

    computed: {
        filteredItems() {
            return this.items.filter((item) => this.checkAuth(item));
        },
        currentUserRoles() {
            // Get user roles from multiple possible sources
            if (
                this.$store.state.auth.userRoles &&
                this.$store.state.auth.userRoles.length > 0
            ) {
                return this.$store.state.auth.userRoles;
            } else if (this.$store.state.auth.userData?.userData?.roles) {
                return this.$store.state.auth.userData.userData.roles;
            } else if (this.$store.state.auth.userData?.roles) {
                return this.$store.state.auth.userData.roles;
            }
            return [];
        },
    },

    created() {
        this.setItems();
        setTimeout(() => {
            var childs = this.filteredItems.filter((item) => {
                return (
                    item.children &&
                    item.children.some((it) => {
                        return it.to == this.$route.path;
                    })
                );
            });
            if (childs && childs.length > 0) {
                childs[0].active = true;
            }
        }, 200);
    },

    methods: {
        setItems() {
            this.items.push(
                {
                    title: "الرئيسية",
                    icon: "fi fi-rr-home",
                    to: "/",
                    divider: false,
                    auth: [], // No specific roles required - just valid authentication
                },

                {
                    title: "فروعنا",
                    icon: "fi fi-rr-code-branch",
                    to: "/branches",
                    divider: false,
                },
                {
                    title: "الاسئلة الشائعة",
                    icon: "fi fi-rr-question-square",
                    to: "/commonQuestions",
                    divider: false,
                    auth: [],
                },
                {
                    title: "مشاريعنا",
                    icon: "fi fi-rr-briefcase",
                    to: "/projects",
                    divider: false,
                    auth: [],
                },
                {
                    title: "اخبار الشركة",
                    icon: "fi fi-rr-radio-alt",
                    to: "/news",
                    divider: false,
                    auth: [],
                },
                {
                    title: "الاعلانات",
                    icon: "fi fi-rr-ad",
                    to: "/slider",
                    divider: false,
                    auth: [],
                },
                {
                    title: "الاستثمارات",
                    icon: "fi fi-rr-users-alt",
                    to: "/Investments",
                    divider: false,
                    auth: [
                        Roles.Admin,
                        Roles.Administrator,
                        Roles.SuperAdmin,
                        Roles.InvestmentRead, // Specific read permission
                    ],
                },
                {
                    title: "المشرفين",
                    icon: "fi fi-rr-user-crown",
                    to: "/admin",
                    divider: false,
                    auth: [
                        Roles.Admin,
                        Roles.Administrator,
                        Roles.SuperAdmin,
                        Roles.AdminRead, // Specific read permission
                    ],
                },
                {
                    title: "المستخدمين",
                    icon: "fi fi-rr-settings",
                    to: "/users",
                    divider: false,
                    auth: [],
                },
                {
                    title: "تذكيرات",
                    icon: "fi fi-rr-megaphone",
                    to: "/profitRolls",
                    divider: false,
                    auth: [
                        Roles.Admin,
                        Roles.Administrator,
                        Roles.SuperAdmin,
                        Roles.ProfitRollRead, // Specific read permission
                    ],
                }
            );
        },

        checkAuth(item) {
            // return true;
            if (!item.auth || item.auth.length === 0) return true;

            // Get user roles from multiple possible sources

            // Try to get from store state (JWT decoded roles)
            // let decodedToken = jwtDecode();

            let userRoles = [];

            if (typeof this.$store.state.auth.userRoles === "string") {
                userRoles.push(this.$store.state.auth.userRoles);
            } else if (Array.isArray(userRoles)) {
                userRoles = this.$store.state.auth.userRoles;
            }
            // Ensure userRoles is always an array
            if (!Array.isArray(userRoles)) {
                console.log(`user roles4:`, userRoles);
                userRoles = [];
            }

            // Admin, SuperAdmin, and Administrator can access everything
            const superRoles = [
                Roles.Admin,
                Roles.SuperAdmin,
                Roles.Administrator,
            ];
            if (userRoles.some((role) => superRoles.includes(role))) {
                return true;
            }

            // Check if user has any of the required roles
            return item.auth.some((requiredRole) =>
                userRoles.includes(requiredRole)
            );
        },

        getFilteredChildren(item) {
            if (!item.children) return [];
            return item.children.filter((child) => this.checkAuth(child));
        },
    },
    beforeCreate() {},
};
</script>

<style scoped>
.divider--text {
    font-size: 10px;
    color: grey;
    opacity: 0.6;
}

.nav-item-icon {
    font-size: 18px;
}
</style>
